// extracted by mini-css-extract-plugin
export var icon = "_44-3";
export var subtitle = "_44-2";
export var title = "_44-1";
export var value = "_44-0";